<template>
  <div class="ticket-header-card">
    <div style="border-bottom: 1px solid #ebe9f1" class="px-2 py-2">
      <div style="display: flex">
        <div class="chat-filter">
          <div class="filter">
            <h6
              v-for="(option, index) in filterOptions"
              :key="index"
              class="ticket-filter"
              :class="
                option.value === selectedFilterOptions
                  ? 'ticket-card__active'
                  : 'ticket-card__inactive'
              "
              @click="handleClickFilterOption(option.value)"
            >
              {{ $t(option.text) }}
            </h6>
            <hr />
          </div>
        </div>

        <div style="display: flex; gap: 0.5em">
          <div class="ml-1">
            <feather-icon
              v-if="toggleSearchOption"
              icon="XIcon"
              class="search-icon"
              size="18"
              @click="handleToggleSearch"
            />
            <feather-icon
              v-else
              icon="SearchIcon"
              class="search-icon"
              size="18"
              @click="handleToggleSearch"
            />
          </div>

          <FeatherIcon
            class="close-icon"
            style="margin-top: 0.15em"
            icon="XIcon"
            size="23"
            @click="ticketStore.setToggleLeftSidebar(false)"
          />
        </div>
      </div>

      <div v-if="toggleSearchOption" class="search-ticket mt-1">
        <!-- Search -->
        <b-input-group
          v-show="isShowSearch"
          class="input-group-merge w-90 round"
        >
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" class="text-muted" />
          </b-input-group-prepend>
          <b-form-input
            v-model.trim="query.search"
            v-debounce:500ms="handleSearch"
            size="md"
            :placeholder="$t('general.search')"
            clearable
          />
        </b-input-group>
      </div>
    </div>
  </div>
</template>
<script>
import { BInputGroup, BInputGroupPrepend, BFormInput } from "bootstrap-vue";
import { nextTick, ref } from "@vue/composition-api";
import useTicketStore from "@/store-pinia/useTicketStore";

export default {
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
  },
  props: {
    active: {
      type: Boolean,
      defaults: false,
    },
    accountId: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const ticketStore = useTicketStore();
    const filterOptions = [
      {
        value: "",
        text: "filter.all",
      },
      {
        value: "unassigned",
        text: "filter.unassigned",
      },
      {
        value: "resolved",
        text: "filter.resolved",
      },
      {
        value: "mine",
        text: "filter.mine",
      },
      // {
      //   value: 'unread',
      //   text: 'chat.unread',
      // },
      // {
      //   value: 'unresolved',
      //   text: 'chat.unresolved',
      // },
      // {
      //   value: 'resolved',
      //   text: 'chat.resolved',
      // },
    ];

    const inputSearchOptions = ref("");
    const selectedFilterOptions = ref("");
    const toggleSearchOption = ref(false);

    function handleToggleSearch() {
      toggleSearchOption.value = !toggleSearchOption.value;
    }

    function handleClickFilterOption(valueToUpdate) {
      selectedFilterOptions.value = valueToUpdate;
      // ticketStore.selectedTicket = {}
      ticketStore.toggleRightSidebar = false;
      // ticketStore.selectedTicketDetail = {};
      ticketStore.getAsyncOptions.filter = valueToUpdate;
      ticketStore.resetTicketParamsOption();
      ticketStore.setAsyncFilterOptions(valueToUpdate, props.accountId);
      nextTick(() => {
        ticketStore.getTicketsAsync();
      });
    }

    function handleSearch(valueSearch) {
      inputSearchOptions.value = valueSearch.trim();
      ticketStore.getAsyncOptions.search = valueSearch.trim();
      ticketStore.resetTicketParamsOption();
      nextTick(() => {
        ticketStore.getTicketsAsync();
      });
    }

    return {
      ticketStore,
      isShowSearch: true,
      handleClickFilterOption,
      handleSearch,
      handleToggleSearch,
      filterOptions,
      selectedFilterOptions,
      inputSearchOptions,
      toggleSearchOption,
      query: {
        search: "",
      },
      // this.$route.query.search ||
    };
  },
};
</script>
<style lang="scss" scoped>
.ticket-header-card {
  position: -webkit-sticky !important;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 11;
  font-size: 20px;
  box-shadow: 0 4px 24px 0 rgba(47, 47, 47, 0.1);
  border-bottom: 1px solid #ebe9f1;
}

.ticket-card {
  display: flex;
  cursor: pointer;
  align-items: center;
}

.ticket-card__active {
  @extend .ticket-card;
  color: #8d5185;
  border-bottom: 2px solid #8d5185;
  // padding-left: 1rem !important;
}

.ticket-filter {
  margin-right: 0 !important;
  //padding: 0.25em 1em;
}

// .ticket-card__inactive{
//   @extend .ticket-card;
//   &:hover {
//     background: whitesmoke;
//   }
// }
// .ticket-filter{
//     padding: 1rem;
// }

.chat-filter {
  width: 100%;
  height: 100%;
  /* display: flex; */
  overflow-x: auto !important;
  overflow-y: hidden !important;
  color: #c9c4c4;
  white-space: break-spaces;
}

.filter {
  cursor: pointer;
  align-items: center !important;
  flex: 1;
  gap: 0.75em;
}

.search-ticket {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.search-icon {
  margin-bottom: 0.25em;
  color: #6e6b7b;
  cursor: pointer;
  &:hover {
    color: #8d5185;
    scale: 1.1;
  }
}
.close-icon {
  @extend .search-icon;
  @media (min-width: 1000px) {
    display: none;
  }
}
</style>
